/**
 * Artemis Application Server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * API Version: 10.6
 * Contact: krusche@tum.de
 *
 * NOTE: This file is auto-generated. Do not edit manually.
 */

/**
 * HyperionExerciseVariantApi - API service
 * @generated from OpenAPI specification
 */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VariantJobStart } from '../model/variant-job-start';
import { VariantGenerationRequest } from '../model/variant-generation-request';
import { VariantJobDetail } from '../model/variant-job-detail';
import { VariantJob } from '../model/variant-job';

@Injectable({ providedIn: 'root' })
export class HyperionExerciseVariantApi {
    private readonly http = inject(HttpClient);
    private readonly basePath = '';

    /**
     *
     *
     * @param jobId
     */
    cancelJob(jobId: string): Observable<void> {
        const jobIdPath = encodeURIComponent(String(jobId));
        const url = `${this.basePath}/api/hyperion/variant-jobs/${jobIdPath}`;
        return this.http.delete<void>(url);
    }

    /**
     *
     *
     * @param exerciseId
     * @param variantGenerationRequest
     */
    generateVariant(exerciseId: number, variantGenerationRequest: VariantGenerationRequest): Observable<VariantJobStart> {
        const url = `${this.basePath}/api/hyperion/exercises/${exerciseId}/generate-variant`;
        return this.http.post<VariantJobStart>(url, variantGenerationRequest);
    }

    /**
     *
     *
     * @param jobId
     */
    getJobDetail(jobId: string): Observable<VariantJobDetail> {
        const jobIdPath = encodeURIComponent(String(jobId));
        const url = `${this.basePath}/api/hyperion/variant-jobs/${jobIdPath}`;
        return this.http.get<VariantJobDetail>(url);
    }

    /**
     *
     *
     */
    getJobsOfCurrentUser(): Observable<Array<VariantJob>> {
        const url = `${this.basePath}/api/hyperion/variant-jobs`;
        return this.http.get<Array<VariantJob>>(url);
    }

}
